import { Deserializer } from './serialization/deserializer';
import { Serializer } from './serialization/serializer';
import { CrossNetworkReference } from './utils/cross-network-ref';

export function onClientOrServerStart(Game) {
    const resources = [CrossNetworkReference, Game, ...Game.functions];

    Serializer.registerStaticResources(resources);
    Deserializer.registerStaticResources(resources);
}